'use es6';

import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withEditorActionsAndEvents from 'ContentEditorUI/components/hoc/withEditorActionsAndEvents';
import EPSideToolbar from 'editor-components/sidebar/EPSideToolbar';
import { setActivePatagoniaPanel, closePatagoniaSidebar, openPatagoniaSidebar, patagoniaSidebarAnimationFinished as patagoniaSidebarAnimationFinishedAction } from 'ContentEditorUI/redux/actions/panelActions';
import { getActiveSidebarPanel, getIsPatagoniaSidebarCollapsed, getSidebarCategory } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getPreviewIframeWrapperElement, getSidebarIframeWrapperElement } from 'ContentEditorUI/lib/layoutDom';
import WidgetAddController from 'ContentEditorUI/controllers/WidgetAddController';
import PreviewIframeStylesManager from 'ContentEditorUI/utils/PreviewIframeStylesManager';
import SidebarIframeStylesManager from 'ContentEditorUI/utils/SidebarIframeStylesManager';
import { getActiveSidebarPanelType } from 'ContentEditorUI/utils/sidebarUtil';
import { getCanUseUniversalThemeEditor } from 'ContentEditorUI/redux/selectors/authSelectors';
const mapStateToProps = state => ({
  activePanel: getActiveSidebarPanel(state),
  isPatagoniaSidebarCollapsed: getIsPatagoniaSidebarCollapsed(state),
  selectedSidebarCategory: getSidebarCategory(state),
  canUseUniversalThemeEditor: getCanUseUniversalThemeEditor(state)
});
const mapDispatchToProps = {
  setActivePanel: setActivePatagoniaPanel,
  closePatagonia: closePatagoniaSidebar,
  openPatagonia: openPatagoniaSidebar,
  patagoniaSidebarAnimationFinished: patagoniaSidebarAnimationFinishedAction
};
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
class StandardSidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.onSidebarToggleAnimationFrame = newSidebarWidth => {
      this.getPreviewIframeWrapperElement().style.left = `${newSidebarWidth}px`;
      this.getSidebarIframeWrapperElement().style.left = `${newSidebarWidth - 380}px`;
    };
    this.handleOpenPatagoniaSidebar = () => {
      const {
        openPatagonia
      } = this.props;
      UsageTracker.trackEditorInteraction({
        action: 'Toggle Sidebar',
        event: 'Open sidebar'
      });
      openPatagonia();
    };
    this.handleClosePatagoniaSidebar = () => {
      const {
        closePatagonia
      } = this.props;
      UsageTracker.trackEditorInteraction({
        action: 'Toggle Sidebar',
        event: 'Close sidebar'
      });
      closePatagonia();
    };
    this.handleUpdatePanel = type => {
      const {
        canUseUniversalThemeEditor,
        setActivePanel
      } = this.props;
      if (type) {
        UsageTracker.trackEditorInteraction({
          action: 'Toggle Sidebar',
          event: 'Set sidebar panel',
          category: getActiveSidebarPanelType(canUseUniversalThemeEditor, type)
        });
      }
      setActivePanel(type);
    };
    this.adjustSidebarScrollHeightForFireAlarm = () => {
      const {
        sidebarRef
      } = this;
      if (!sidebarRef || !sidebarRef.current) {
        return;
      }
      const fireAlarm = document.querySelector('.fire-alarm_alarms');
      if (fireAlarm === null) {
        return;
      }
      const sidebarContent = sidebarRef.current.querySelector('.sidebar-scrollable-tab-panel');
      if (!sidebarContent) {
        return;
      }
      const nextHeight = sidebarContent.getBoundingClientRect().height - fireAlarm.offsetHeight;
      sidebarContent.style.height = `${nextHeight}px`;
    };
    this.onPatagoniaSidebarToggleAnimationEnd = () => {
      const {
        patagoniaSidebarAnimationFinished
      } = this.props;
      PreviewIframeStylesManager.onToggleAnimationEnd();
      SidebarIframeStylesManager.onSidebarTogleAnimationEnd();
      patagoniaSidebarAnimationFinished();
      this.adjustSidebarScrollHeightForFireAlarm();
    };
    this.onPatagoniaSidebarToggleAnimationFrame = (newSidebarWidth, animationType) => {
      SidebarIframeStylesManager.onSidebarToggleAnimationFrame(newSidebarWidth);
      PreviewIframeStylesManager.onPreviewToggleAnimationFrame(newSidebarWidth, animationType);
    };
    this.widgetAddController = new WidgetAddController({
      bus: props.bus,
      saveActions: props.saveActions
    });
    this.onPatagoniaSidebarToggleAnimationStart = this.onPatagoniaSidebarToggleAnimationStart.bind(this);
    this.sidebarRef = /*#__PURE__*/createRef(null);
  }
  getPreviewIframeWrapperElement() {
    if (!this.previewIframeWrapperElement) {
      this.previewIframeWrapperElement = getPreviewIframeWrapperElement();
    }
    return this.previewIframeWrapperElement;
  }
  getSidebarIframeWrapperElement() {
    if (!this.sidebarIframeWrapperElement) {
      this.sidebarIframeWrapperElement = getSidebarIframeWrapperElement();
    }
    return this.sidebarIframeWrapperElement;
  }

  // In order to keep the preview iframe flush with the sidebar as it opens/closes
  // we use requestAnimationFrame in EPSidebar to simulate the css animation
  // and directly update the iframes wrapppers' position to match the
  // current sidebar width as the animation progresses.
  onPatagoniaSidebarToggleAnimationStart() {
    PreviewIframeStylesManager.onToggleAnimationStart();
    SidebarIframeStylesManager.onSidebarToggleAnimationStart(this.props.selectedSidebarCategory);
  }
  render() {
    const {
      sidebarOptions,
      isPatagoniaSidebarCollapsed,
      activePanel
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      ref: this.sidebarRef,
      children: /*#__PURE__*/_jsx(EPSideToolbar, {
        collapsed: isPatagoniaSidebarCollapsed,
        onCollapse: this.handleClosePatagoniaSidebar,
        onExpand: this.handleOpenPatagoniaSidebar,
        activePanel: activePanel,
        sidebarOptions: sidebarOptions,
        onToggleAnimationEnd: this.onPatagoniaSidebarToggleAnimationEnd,
        onToggleAnimationStart: this.onPatagoniaSidebarToggleAnimationStart,
        onToggleAnimationFrame: this.onPatagoniaSidebarToggleAnimationFrame,
        handlePanelChange: this.handleUpdatePanel,
        onContentShown: SidebarIframeStylesManager.showIframeElement,
        onWidthAnimationFrame: SidebarIframeStylesManager.onWidthAnimatonFrame,
        onWidthAnimationStart: SidebarIframeStylesManager.onWidthAnimationStart,
        onWidthAnimationEnd: SidebarIframeStylesManager.onWidthAnimationEnd,
        flexShrink: 0
      })
    });
  }
}
StandardSidebarContainer.propTypes = {
  saveActions: PropTypes.object.isRequired,
  bus: PropTypes.object.isRequired,
  setActivePanel: PropTypes.func.isRequired,
  activePanel: PropTypes.string.isRequired,
  closePatagonia: PropTypes.func.isRequired,
  openPatagonia: PropTypes.func.isRequired,
  isPatagoniaSidebarCollapsed: PropTypes.bool,
  sidebarOptions: PropTypes.array,
  selectedSidebarCategory: PropTypes.string.isRequired,
  patagoniaSidebarAnimationFinished: PropTypes.func.isRequired,
  canUseUniversalThemeEditor: PropTypes.bool
};
export default connect(mapStateToProps, mapDispatchToProps)(withEditorActionsAndEvents(StandardSidebarContainer));